module.exports = __webpack_public_path__ + "static/media/19-7.1e1a4c57.mp3";